/* eslint-disable @ts-intl/ts-intl/no-raw-text */
import { currentWallet, useDesiredChain } from '@cronos-app/wallet';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toaster } from '@ui/components/Atoms/Toast';
import { getSDK } from '@ui/utils';
import { useTranslations } from 'next-intl';
import { useState } from 'react';

import { getUseBaraBalanceQueryKey } from '../useBaraBalance';
import { getUseBaraVaultUserInfoQueryKey } from './useBaraVaultUserInfo';

const useBaraHarvest = () => {
  const t = useTranslations();
  const desiredChainId = useDesiredChain();
  const sdk = getSDK(desiredChainId);
  const [isLoading, setIsLoading] = useState(false);
  const account = currentWallet.useAccount();
  const provider = currentWallet.useProvider();
  const isWrongNetwork = currentWallet.useIsWrongNetwork();
  const queryClient = useQueryClient();

  const data = useMutation(
    ['BaraVault.Harvest'],
    async () => {
      try {
        const signer = await provider?.getSigner();
        const baraVaultContract = sdk.getBaraVault(signer);

        setIsLoading(true);
        if (account && !isWrongNetwork) {
          const harvestRet = await baraVaultContract.deposit(0, 0);

          toaster.create({
            title: t('common.Harvesting BARA reward'),
            type: 'loading',
            id: harvestRet.hash,
            meta: { txHash: harvestRet.hash },
          });

          await harvestRet.wait();

          toaster.dismiss(harvestRet.hash);

          toaster.success({
            title: t('common.Harvest_Success_Toast_Title'),
            description: t('common.Harvest_Success_Toast_Message'),
          });
        }
      } catch (e) {
        toaster.error({
          title: t('common.Harvest_Error_Toast_Title'),
          description: t('common.Harvest_Error_Toast_Message'),
        });
        setIsLoading(false);
      }
    },
    {
      onError: () => {
        setIsLoading(false);
      },
      onSuccess: () => {
        setIsLoading(false);
        queryClient.invalidateQueries(getUseBaraVaultUserInfoQueryKey(account));
        queryClient.invalidateQueries(getUseBaraBalanceQueryKey(account));
      },
    },
  );

  return {
    ...data,
    isLoading,
  };
};

export default useBaraHarvest;
